module.exports = __webpack_public_path__ + "static/media/Pin.67229031.svg";